import React from 'react';
import * as R from 'ramda';

import anticipa from './../../../assets/images/svg/112-person-white.svg';
import facilita from './../../../assets/images/svg/113-funeral.svg';
import serenita from './../../../assets/images/svg/145-customer-service.svg';


export const DossierTypeSection = ({ account, setAccount, dossierTypeOptions, steps, etablissement}) => {
    return (
        <div className="card">
            <div className="card-header py-0 pr-0 pl-4" id="headingTypeDossier" role="button">
                <div className="flex-row align-items-center justify-content-lg-between" data-toggle="collapse" data-target="#accordionTypeDossier" aria-expanded="true" aria-controls="accordionTypeDossier">
                    <h2 className="h3 font-weight-black my-auto"><i className={"eva eva-checkmark-circle-outline fs-4 align-middle mr-1 ml-n4" + (steps[0] === true ? ' text-success' : '')}></i><span className="align-middle">Type de dossier</span></h2>
                    <button type="button" className="btn btn-icon p-0 text-uppercase font-weight-demi fs-4 my-auto ml-auto m-lg-1 o-30" name="refPrincipal"><i className="eva eva-arrow-ios-downward-outline"></i></button>
                </div>
                <hr className="mt-2 mb-0 border-gray" />
            </div>
            <div className="card-body pl-4 pr-0 collapse show" id="accordionTypeDossier" aria-labelledby="headingTypeDossier" data-parent="#accordionCreateDossier">
                <p className="fs-3 font-weight-demi">Choisissez le type de dossier que vous souhaitez créer:</p>
                <div className="grid grid-sm-narrow grid-xl-4 grid-hd-5">
                    <div className={"card picker-card aling-items-center text-center"+(account.type === dossierTypeOptions.anticipa ? ' shadow active': '')} onClick={() => {setAccount({...account, type: dossierTypeOptions.anticipa})}}>
                        <div className="card-header pt-sm pb-0">
                            <div className="flex-column bg-gradient-primary text-white h-6 w-6 rounded-max text-center">
                                <img className="img-fluid m-auto" src={anticipa} alt="Anticipa" />
                            </div>
                        </div>
                        <div className="card-body pb-sm pt-xs">
                            <h5 className="h5 font-weight-demi text-uppercase">Anticipa</h5>
                            <p className="h6 mb-0">Dossier administratif qui accompagne vos clients toute leur vie</p>
                        </div>
                    </div>
                    <div className={"card picker-card aling-items-center text-center"+(account.type === dossierTypeOptions.facilita ? ' shadow active': '')} onClick={() => {setAccount({...account, type: dossierTypeOptions.facilita})}}>
                        <div className="card-header pt-sm pb-0">
                            <div className="flex-column bg-dim h-6 w-6 rounded-max text-center">
                                <img className="img-fluid m-auto" src={facilita} alt="facilita" />
                            </div>
                        </div>
                        <div className="card-body pb-sm pt-xs">
                            <h5 className="h5 font-weight-demi text-uppercase">Facilita</h5>
                            <p className="h6 mb-0">Dossier qui accompagne dans toutes les démarches lors d'un décès</p>
                        </div>
                    </div>
                    {
                        etablissement.isSerenita ?
                            <div className={"card picker-card aling-items-center text-center"+(account.type === dossierTypeOptions.serenita ? ' shadow active': '')} onClick={() => {setAccount({...account, type: dossierTypeOptions.serenita})}}>
                                <div className="card-header pt-sm pb-0">
                                    <div className="flex-column bg-dim h-6 w-6 rounded-max text-center">
                                        <img className="img-fluid m-auto" src={serenita} alt="facilita" />
                                    </div>
                                </div>
                                <div className="card-body pb-sm pt-xs">
                                    <h5 className="h5 font-weight-demi text-uppercase">Serenita</h5>
                                    <p className="h6 mb-0">Accompagnement téléphonique à la complétude du dossier et réalisation des démarches après décès</p>
                                </div>
                            </div>
                        :
                            ""
                    }
                </div>
                <div className="invalid-feedback alert-danger alert">Veuillez choisir une option</div>
            </div>
        </div>
    )
}